/**
 * The entry point for Webpack bundler.
 */

import "./polyfills";
import "./app";
